/* Jhilke timeline (FS, 2026-10-12): the small runtime behind snippets/jhilke-timeline-styles.liquid.
   Browsers with CSS scroll-driven animations need none of this except the finished-state switch below.
   1. Finished state: a full-page capture (the viewport grows to the page height) or print gets .jh-tl-done on <html>,
      so every line, pin and text shows its final state instead of a mid-scroll frame.
   2. Fallback (Firefox, older Safari): adds .jh-tl-io to <html> and .is-on to each stop and reveal hook once its top
      reaches the reading line (stops) or 90 percent of the viewport (text). An IntersectionObserver does the work; a
      passive, frame-throttled sweep catches anything a fast fling or an anchor jump carried past without crossing.
   No layout writes during scroll; reads are batched before the class changes. Fail-open: any error removes .jh-tl-io. */
(function () {
  'use strict';
  var root = document.documentElement;
  var done = function () { root.classList.add('jh-tl-done'); };
  try {
    // A capture tool grows the viewport to (nearly) the page height; capture emulation often resizes screen too, so
    // compare with the page as well as with the screen.
    var big = function () {
      var vh = window.innerHeight, ph = document.documentElement.scrollHeight;
      return vh > 2000 && (vh >= ph * 0.8 || vh > (screen.height || 0) * 1.6);
    };
    if (big()) done();
    window.addEventListener('resize', function () { if (big()) done(); });
    window.addEventListener('beforeprint', done);
  } catch (e) { /* the finished state is a safety net only */ }

  try {
    if (!root.classList.contains('jh-m')) return;
    if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;
    if (!('IntersectionObserver' in window)) return;
    var stops = Array.prototype.slice.call(document.querySelectorAll('.jh-tl__stop'));
    var hooks = Array.prototype.slice.call(document.querySelectorAll('.jh-tl [data-tl]'));
    if (!stops.length && !hooks.length) return;
    var pen = function () { return window.innerHeight * 0.55; };
    var on = function (el) { el.classList.add('is-on'); };
    // Already at or above the line at boot: final state at once
    var vh = window.innerHeight;
    stops = stops.filter(function (el) { if (el.getBoundingClientRect().top < pen()) { on(el); return false; } return true; });
    hooks = hooks.filter(function (el) { if (el.getBoundingClientRect().top < vh * 0.9) { on(el); return false; } return true; });
    root.classList.add('jh-tl-io');

    var ioStop = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting || e.boundingClientRect.top < 0) { on(e.target); ioStop.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -45% 0px' });
    var ioHook = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting || e.boundingClientRect.top < 0) { on(e.target); ioHook.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    stops.forEach(function (el) { ioStop.observe(el); });
    hooks.forEach(function (el) { ioHook.observe(el); });

    var queued = false;
    var sweep = function () {
      queued = false;
      var p = pen(), line = window.innerHeight * 0.9;
      var s = stops.filter(function (el) { return !el.classList.contains('is-on') && el.getBoundingClientRect().top < p; });
      var h = hooks.filter(function (el) { return !el.classList.contains('is-on') && el.getBoundingClientRect().top < line; });
      s.forEach(function (el) { on(el); ioStop.unobserve(el); });
      h.forEach(function (el) { on(el); ioHook.unobserve(el); });
      stops = stops.filter(function (el) { return !el.classList.contains('is-on'); });
      hooks = hooks.filter(function (el) { return !el.classList.contains('is-on'); });
      if (!stops.length && !hooks.length) window.removeEventListener('scroll', onScroll);
    };
    var onScroll = function () { if (!queued) { queued = true; requestAnimationFrame(sweep); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('hashchange', onScroll);
  } catch (e) {
    root.classList.remove('jh-tl-io');
  }
})();
